module.exports = __webpack_public_path__ + "media/images/woman-00345ba4.jpg";